import { useParams } from "react-router-dom";
import { useEffect, useMemo, useRef, useState } from "react";
import { ISourceOptions, MoveDirection, OutMode } from "@tsparticles/engine";
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim";

import AlarmEventApi from "../../../../api/AlarmEventApi";
import Navigator from "./components/navigator/Navigator";
import DeviceModel3D from "./components/device-model-3d/DeviceModel3D";
import DeviceDetails from "./components/device-details/DeviceDetails";
import DeviceMetrics from "./components/device-metrics/DeviceMetrics";
import DeviceAlarms from "./components/device-alarms/DeviceAlarms";
import ContentCard from "./common/content-card/ContentCard";
import EventManager from "./common/event-manager/EventManager";
import { DeviceDetailsContent, DeviceDetailsBorderTop, DeviceDetailsBorder, DeviceDetailsScreenInnerWrapper, DeviceDetailsScreenWrapper, DeviceDetailsWrapper, DeviceModel3DWrapper, ScreenTitleBar, AlarmToggleBox, AlarmToggleText } from "./DeviceDetailsScreen.styled";

let globalParticlesEngineInited = false;

interface DeviceDetailsScreenProps {

}

let DeviceDetailsScreen: React.FC<DeviceDetailsScreenProps> = (props)=> {
    // parameters
    let params = useParams();
    let { deviceId } = useParams();

    // event manager
    let eventManagerRef = useRef(new EventManager());

    // state
    let [particlesEngineInited, setParticlesEnineInited] = useState(globalParticlesEngineInited);
    // alarm presence state
    let [hasAlarmEvents, setHasAlarmEvents] = useState<boolean | null>(null);
    let [isAlarmEventsChecked, setAlarmEventsChecked] = useState(false);

    // function
    let initializeScreenWrapper = (dom)=> {

    };

    // check whether device has any alarm events; used to hide/show alarms card
    useEffect(()=> {
        if (!deviceId) {
            setHasAlarmEvents(false);
            return;
        }

        let alarmEventApi = new AlarmEventApi();
        let load = async ()=> {
            try {
                let resp = await alarmEventApi.queryViews({
                    deviceId: deviceId,
                    pageNo: 1,
                    pageSize: 1,
                });
                let elements = resp?.data?.data?.elements || [];
                setHasAlarmEvents(elements.length > 0);
            } catch (e) {
                setHasAlarmEvents(false);
            }
        };

        load();
    }, [deviceId]);

    // particles options
    const options: ISourceOptions = useMemo(
        () => ({
            background: {
                color: {
                    value: "transparent",
                },
            },
            fpsLimit: 120,
            interactivity: {
                events: {
                    onClick: {
                        enable: true,
                        mode: "push",
                    },
                    onHover: {
                        enable: true,
                        mode: "repulse",
                    },
                },
                modes: {
                    push: {
                        quantity: 4,
                    },
                    repulse: {
                        distance: 200,
                        duration: 0.4,
                    },
                },
            },
            particles: {
                color: {
                    value: "#0f62fe",
                },
                links: {
                    color: "#0f62fe",
                    distance: 150,
                    enable: true,
                    opacity: 0.5,
                    width: 1,
                },
                move: {
                    direction: MoveDirection.none,
                    enable: true,
                    outModes: {
                        default: OutMode.out,
                    },
                    random: false,
                    speed: 1,
                    straight: false,
                },
                number: {
                    density: {
                        enable: true,
                    },
                    value: 80,
                },
                opacity: {
                    value: 0.5,
                },
                shape: {
                    type: "circle",
                },
                size: {
                    value: { min: 1, max: 3 },
                },
            },
            detectRetina: true,
        }),
        [],
    );
    
    // particles typescript
    useEffect(() => {
        if (particlesEngineInited && globalParticlesEngineInited) {
            return;
        }

        initParticlesEngine(async (engine) => {
        // await loadAll(engine);
        // await aloadFull(engine);
        await loadSlim(engine);
        // await loadBasic(engine);
        }).then(() => {
            globalParticlesEngineInited = true;
            setParticlesEnineInited(true);
        });
    }, []);

    // render
    return (
        <DeviceDetailsScreenWrapper ref={(dom)=> initializeScreenWrapper(dom)}>
            {particlesEngineInited && <Particles
                id="tsparticles"
                options={options}
            />}
            
            <DeviceDetailsScreenInnerWrapper>
                <ScreenTitleBar>
                    <Navigator selected="DEVICE_DETAILS"/>
                </ScreenTitleBar>

                <DeviceDetailsBorderTop src="/static/images/big-screen/v2/device-details-title-background.png"/>
                <DeviceDetailsBorder src="/static/images/big-screen/v2/device-details-border.png"/>

                <DeviceDetailsContent>
                    <ContentCard 
                        style={{
                            position: 'absolute',
                            left: '10px',
                            top: '5px',
                            zIndex: '200',
                            backgroundColor: 'rgba(14, 17, 39, 0.774)'
                        }}
                        titleCn="设备信息" 
                        titleEn="DEVICE INFORMATION">
                        <DeviceDetailsWrapper>
                            <DeviceDetails eventManager={eventManagerRef.current} deviceId={deviceId} />
                        </DeviceDetailsWrapper>
                    </ContentCard>

                        {hasAlarmEvents ? (
                            isAlarmEventsChecked ? (
                                <ContentCard 
                                    style={{
                                        position: 'absolute',
                                        left: '10px',
                                        bottom: '5px',
                                        zIndex: '200',
                                        backgroundColor: 'rgba(14, 17, 39, 0.774)',
                                        height: '150px',
                                        width: '1420px'
                                    }}
                                    onTitleClick={() => setAlarmEventsChecked(false)}
                                    titleCn="告警信息" 
                                    titleEn="AlARM INFORMATION">
                                    <DeviceAlarms deviceId={deviceId} />
                                </ContentCard>
                            ) : (
                                <AlarmToggleBox onClick={() => setAlarmEventsChecked(true)}>
                                    <AlarmToggleText>告警信息</AlarmToggleText>
                                </AlarmToggleBox>
                            )
                        ) : null}

                    <DeviceModel3DWrapper>
                        <DeviceModel3D eventManager={eventManagerRef.current} />
                    </DeviceModel3DWrapper>
                    
                    <ContentCard 
                         style={{
                            position: 'absolute',
                            right: '25px',
                            top: '0px',
                            zIndex: '200',
                            height: '960px',
                            width: '420px',
                            backgroundColor: 'rgba(14, 17, 39, 0.774)'
                        }}
                        // style={{
                        //     gridColumn: '3 / 4',
                        //     gridRow: '1 / 3',
                        // }}
                        titleCn="数据曲线" 
                        titleEn="METRICS CHARTS">
                        <DeviceMetrics deviceId={deviceId} eventManager={eventManagerRef.current} />
                    </ContentCard>

                </DeviceDetailsContent>
            </DeviceDetailsScreenInnerWrapper>

        </DeviceDetailsScreenWrapper>
    )
};

export default DeviceDetailsScreen;

